// import CrmSelect2_1 from './crm_select_2_1'
import { CrmSelect2_2 } from '../ui/ot'

export default function CrmSelect2({
    showComponent = [
        // "CrmSelect2_1",
        "CrmSelect2_2",
    ],
    // CrmSelect2_1Props = {
    //     items: [
    //         { label: '管理首頁', path: '/templates/list' },
    //         { label: '樣式建立', path: '/templates/create' },
    //         { label: '樣式儲存資料夾設定', path: '/templates/categories' },
    //     ],
    // },
    CrmSelect2_2Props = {
        name: "",
        onValueChange: () => { },
        multiple: false,
        defaultValue: "",
        showSearch: true,
        style: {},
        placeholder: '請選擇',
        allowClear: true,
        treeDefaultExpandAll: false,
        onChange: () => { },
        treeData: [],
        itemHeight: 36,
        height: 300,
        loadData: false,
        value: "",
        createMode: true,
    },
}, ref) {
    return (
        <>

            {/* {showComponent.includes("CrmSelect2_1") && (
                        <CrmSelect2_1  {...CrmSelect2_1Props} handleClick={CrmSelect2_1_handleClick} />
                    )} */}
            {showComponent.includes("CrmSelect2_2") && (
                <CrmSelect2_2  {...CrmSelect2_2Props} />
            )}
        </>
    )
}

